import { NgModule } from '@angular/core'
import { ConfigurationOptionSelectComponent } from './configuration-option-select/configuration-option-select.component'
import { ConfigurationOptionSelectDurationComponent } from './configuration-option-select/configuration-option-select-duration.component'
import { ConfigurationOptionSelectKmPerYearComponent } from './configuration-option-select/configuration-option-select-km-per-year.component'
import { ConfigurationOptionSelectAdvancedComponent } from './configuration-option-select-advanced/configuration-option-select-advanced.component'
import { ConfigurationOptionTextComponent } from './configuration-option-text/configuration-option-text.component'
import { ConfigurationOptionTextDriverComponent } from './configuration-option-text-driver/configuration-option-text-driver.component'
import { ConfigurationOptionCompanyForm } from './configuration-option-company-form/configuration-option-company-form.component'
import { ConfigurationOptionSelectAdvancedColorComponent } from './configuration-option-select-advanced-color/configuration-option-select-advanced-color.component'
import { ConfigurationOptionSelectAdvancedDownpaymentComponent } from './configuration-option-select-advanced-downpayment/configuration-option-select-advanced-downpayment.component'
import { ConfigurationOptionSelectAdvancedRimsComponent } from './configuration-option-select-advanced-rims/configuration-option-select-advanced-rims.component'
import { ConfigurationOptionSelectAdvancedInteriorComponent } from './configuration-option-select-advanced-interior/configuration-option-select-advanced-interior.component'
import { ConfigurationOptionsFactoryComponent } from './configuration-options-factory/configuration-options-factory.component'
import { CommonModule } from '@angular/common'
import { CheckoutUiModule } from '../../ui/checkout-ui.module'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { UiModule } from '../../../../../ui/monolith/ui.module'
import { DealUiModule } from '../../../ui/deal-ui.module'
import { ConfigurationOptionSelectAdvancedEditionComponent } from './configuration-option-select-advanced-edition/configuration-option-select-advanced-edition.component'
import { ConfigurationFactoryTabsComponent } from './configuration-factory-tabs/configuration-factory-tabs.component'
import { RouterModule } from '@angular/router'
import { ConfigurationOptionSelectAdvancedFsdComponent } from './configuration-option-select-advanced-fsd/configuration-option-select-advanced-fsd.component'
import { ConfigurationOptionSelectAdvancedInteriorTripleChoiceComponent } from './configuration-option-select-advanced-interior-triple-choice/configuration-option-select-advanced-interior-triple-choice.component'
import { TenantCurrencyModule } from 'framework/tenant-currency/tenant-currency.module'
import { AccessoryFilter } from './accessory-filter.pipe'
import { ConfigurationOptionSelectAdvancedSteeringWheelComponent } from './configuration-option-select-advanced-steeringwheel/configuration-option-select-advanced-steeringwheel.component'

const COMPONENTS = [
    ConfigurationOptionSelectComponent,
    ConfigurationOptionSelectDurationComponent,
    ConfigurationOptionSelectKmPerYearComponent,
    ConfigurationOptionSelectAdvancedComponent,
    ConfigurationOptionTextComponent,
    ConfigurationOptionTextDriverComponent,
    ConfigurationOptionCompanyForm,
    ConfigurationOptionSelectAdvancedColorComponent,
    ConfigurationOptionSelectAdvancedDownpaymentComponent,
    ConfigurationOptionSelectAdvancedRimsComponent,
    ConfigurationOptionSelectAdvancedSteeringWheelComponent,
    ConfigurationOptionSelectAdvancedInteriorComponent,
    ConfigurationOptionSelectAdvancedInteriorTripleChoiceComponent,
    ConfigurationOptionsFactoryComponent,
    ConfigurationOptionSelectAdvancedEditionComponent,
    ConfigurationOptionSelectAdvancedFsdComponent,
    ConfigurationFactoryTabsComponent,
    AccessoryFilter,
]

@NgModule({
    imports: [
        CommonModule,
        UiModule,
        CheckoutUiModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        CheckoutUiModule,
        DealUiModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        RouterModule,
        TenantCurrencyModule,
    ],
    declarations: COMPONENTS,
    exports: COMPONENTS,
})
export class CheckoutFactoryComponentsModule {}
